import { logger } from '@libs/core';
import type { StoreSearchResult } from '@libs/common-node';
import apiProxyClient from '@libs/api-proxy-client';

export type InventoryHitStore = {
    id: number;
    qty: number;
};
type StoreSku = { store: string; sku: string };
export const getStoresWhereInStock = async (
    productVariant: number | string | undefined,
    storeList: StoreSearchResult[],
    isCPC?: boolean
) => {
    try {
        const storesku: StoreSku[] = storeList.reduce<StoreSku[]>(
            (acc, store) => {
                if (
                    isCPC ? store?.Store?.StoreNumber : store?.Store?.objectID
                ) {
                    acc.push({
                        store: `${
                            isCPC
                                ? store?.Store?.StoreNumber
                                : store?.Store?.objectID
                        }`,
                        sku: `${productVariant}`,
                    });
                }
                return acc;
            },
            []
        );

        const storesWhereInStock =
            await apiProxyClient.inventory.getProductInventoryPairs(storesku);

        return storesWhereInStock.reduce<InventoryHitStore[]>(
            (stores, inventoryItem) => {
                // Get all keys from the store object except 'sku'
                const storeIds = Object.keys(inventoryItem).filter(
                    key => key !== 'sku'
                );
                // Transform each store ID into the required format
                const newStores = storeIds
                    .map(storeId => {
                        const id = parseInt(storeId, 10);
                        // Skip invalid store IDs
                        if (Number.isNaN(id)) {
                            return null;
                        }
                        return {
                            id,
                            qty: inventoryItem[storeId] as number,
                        };
                    })
                    .filter((item): item is InventoryHitStore => item !== null);
                // Combine the previously processed stores with the new ones
                return [...stores, ...newStores];
            },
            []
        );
    } catch (error) {
        logger.error('Error getStoresWhereInStock: %o', error);

        return [];
    }
};
